// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__HWfxF","filesListContainer":"PosDisputesFiles_filesListContainer__2SAYr","filesButton":"PosDisputesFiles_filesButton__3dXHT"};